/*
 * Subtle confirmation tone, generated with Web Audio (no external asset, CSP-clean).
 * Two soft sine notes (E5 → A5) with a quick attack and a short, gentle decay.
 * Intentionally low gain — meant to be reassuring, not celebratory.
 */

let ctx: AudioContext | null = null;

function ensureContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  type WithWebkit = typeof window & { webkitAudioContext?: typeof AudioContext };
  const w = window as WithWebkit;
  const Ctor = window.AudioContext ?? w.webkitAudioContext;
  if (!Ctor) return null;
  if (!ctx) ctx = new Ctor();
  if (ctx.state === 'suspended') {
    // Best-effort resume; browsers allow this from a user-gesture handler.
    void ctx.resume().catch(() => {});
  }
  return ctx;
}

function playTone(audio: AudioContext, freq: number, startAt: number, duration: number, peakGain: number) {
  const osc = audio.createOscillator();
  osc.type = 'sine';
  osc.frequency.value = freq;

  const gain = audio.createGain();
  gain.gain.setValueAtTime(0, startAt);
  gain.gain.linearRampToValueAtTime(peakGain, startAt + 0.012); // 12ms attack
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);

  osc.connect(gain).connect(audio.destination);
  osc.start(startAt);
  osc.stop(startAt + duration + 0.02);
}

export function playCorrectPing(): void {
  const audio = ensureContext();
  if (!audio) return;
  const now = audio.currentTime;
  // Two-note step, both quiet, total ~280ms.
  playTone(audio, 659.25, now,        0.16, 0.08); // E5
  playTone(audio, 880.00, now + 0.10, 0.20, 0.07); // A5
}
